export { UIModule } from '@macs-frontend/web/features/ui/ui.module';
